import React, { useState } from 'react';

function Quiz({ question, options, correctAnswerIndex }) {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleOptionSelect = (index) => {
        if (!isSubmitted) {
            setSelectedOption(index);
        }
    };

    const handleSubmit = () => {
        setIsSubmitted(true);
    };

    const getOptionClass = (index) => {
        let className = "quiz-option";
        if (selectedOption === index) {
            className += " selected";
        }
        if (isSubmitted) {
            if (index === correctAnswerIndex) {
                className += " correct";
            } else if (index === selectedOption && index !== correctAnswerIndex) {
                className += " incorrect";
            }
        }
        return className;
    };

    return (
        <div className="quiz-container">
            <h4 className="quiz-question">{question}</h4>
            <div className="quiz-options">
                {options.map((option, index) => (
                    <div
                        key={index}
                        className={getOptionClass(index)}
                        onClick={() => handleOptionSelect(index)}
                    >
                        {option}
                    </div>
                ))}
            </div>
            {!isSubmitted && (
                <button 
                    className="btn-pill mt-3" 
                    onClick={handleSubmit}
                    disabled={selectedOption === null}
                >
                    Check Answer
                </button>
            )}
            {isSubmitted && (
                <div className="quiz-feedback mt-3">
                    {selectedOption === correctAnswerIndex ? (
                        <p className="text-success">Correct! Well done.</p>
                    ) : (
                        <p className="text-danger">Incorrect. Try reviewing the lesson.</p>
                    )}
                </div>
            )}
        </div>
    );
}

export default Quiz;
